import { css, mediaQuery, useMediaQuery } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useFullPlaylist } from '../savedItemsQueries';
import { useIsPartner } from '../../partners';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Box } from 'foundations-components/transitional/components/Box';
import styled from 'foundations-theming/utils';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverlayContainer = styled.div.withConfig({
  displayName: "PlaylistPermissionsWarningMessage__OverlayContainer"
})(["max-width:640px;color:", ";margin:40px;margin-top:200px;text-align:left;", ""], ({
  theme
}) => theme.color['text-core-on-fill-default'], mediaQuery('mobile', css(["text-align:center;margin-top:40px;"])));
const useRestrictedContent = playlist => {
  if (!playlist || !playlist.items) return {};
  const isPlaylistItemPartnerOnly = item => item.visibility.toString().includes('PARTNER'); // there are many visibility types for partners but all should contain 'PARTNER'
  const hasSomeRestrictedContent = playlist.items.some(isPlaylistItemPartnerOnly);
  const hasAllRestrictedContent = playlist.items.every(isPlaylistItemPartnerOnly);
  return {
    hasSomeRestrictedContent,
    hasAllRestrictedContent
  };
};
const PlaylistPermissionsWarningMessage = ({
  playlistId
}) => {
  const {
    playlist
  } = useFullPlaylist(playlistId);
  const isPartner = useIsPartner();
  const {
    isMobile
  } = useMediaQuery();
  const {
    hasSomeRestrictedContent,
    hasAllRestrictedContent
  } = useRestrictedContent(playlist || null);
  if (!playlist || !playlist.items.length) return null;
  if (!isPartner && hasAllRestrictedContent) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "playlist-permissions-warning-overlay",
      children: /*#__PURE__*/_jsx(Overlay, {
        use: "dark",
        width: "100%",
        children: /*#__PURE__*/_jsx("div", {
          style: {
            backdropFilter: 'blur(10px)',
            height: '100%'
          },
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(OverlayContainer, {
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: isMobile ? 'center' : 'start',
                flexDirection: isMobile ? 'column' : 'row-reverse',
                children: [/*#__PURE__*/_jsx(Flex, {
                  flexBasis: isMobile ? 100 : 150,
                  flexShrink: 0,
                  marginInlineStart: isMobile ? '0' : '1000',
                  children: /*#__PURE__*/_jsx(Illustration, {
                    name: "lock",
                    width: "100%"
                  })
                }), /*#__PURE__*/_jsxs(Box, {
                  children: [/*#__PURE__*/_jsx(H4, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.savedItems.playlistDetails.playlistPermissionsOverlayHeading"
                    })
                  }), /*#__PURE__*/_jsx("p", {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.savedItems.playlistDetails.playlistPermissionsOverlayDescription"
                    })
                  }), /*#__PURE__*/_jsx(RouterButton, {
                    to: '/',
                    use: "primary",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.savedItems.playlistDetails.playlistPermissionsOverlayButton"
                    })
                  })]
                })]
              })
            })
          })
        })
      })
    });
  }
  if (!isPartner && hasSomeRestrictedContent) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "playlist-permissions-warning-banner",
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.savedItems.playlistDetails.playlistPermissionsWarningHeading"
        }),
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.savedItems.playlistDetails.playlistPermissionsWarningDescription"
        })
      })
    });
  }
  return null;
};
export default PlaylistPermissionsWarningMessage;